import { render, staticRenderFns } from "./_landing.vue?vue&type=template&id=fd31d0f2"
import script from "./_landing.vue?vue&type=script&lang=js"
export * from "./_landing.vue?vue&type=script&lang=js"
import style0 from "./_landing.vue?vue&type=style&index=0&id=fd31d0f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorFieldHandler: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/FormErrorPopUp.vue').default})
